module.exports = __webpack_public_path__ + "static/Cheetah-53f3c0bca3f514090081fefeb0ca112a.jpg";